module.exports = __webpack_public_path__ + "static/media/A_iko_2_czcionka.c2e3143d.svg";